/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Error_Device_Tilted12Inputs */

const en_us2_body_assessment_error_device_tilted12 = /** @type {(inputs: Body_Assessment_Error_Device_Tilted12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The phone was tilted when the photo was taken. Stand it upright between the floor and navel height, without pointing it up or down.`)
};

const pt_br2_body_assessment_error_device_tilted12 = /** @type {(inputs: Body_Assessment_Error_Device_Tilted12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O celular estava inclinado na hora da foto. Apoie o celular na vertical, entre o chão e a altura do umbigo, sem apontar para cima nem para baixo.`)
};

const es_419_body_assessment_error_device_tilted12 = /** @type {(inputs: Body_Assessment_Error_Device_Tilted12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El teléfono estaba inclinado al tomar la foto. Apóyalo en vertical entre el suelo y la altura del ombligo, sin apuntarlo hacia arriba ni hacia abajo.`)
};

const pt_pt2_body_assessment_error_device_tilted12 = /** @type {(inputs: Body_Assessment_Error_Device_Tilted12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O telemóvel estava inclinado no momento da foto. Apoia-o na vertical, entre o chão e a altura do umbigo, sem apontar para cima nem para baixo.`)
};

const fr_fr2_body_assessment_error_device_tilted12 = /** @type {(inputs: Body_Assessment_Error_Device_Tilted12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le téléphone était incliné au moment de la photo. Pose-le vertical, entre le sol et la hauteur du nombril, sans le pointer vers le haut ni vers le bas.`)
};

const de_de2_body_assessment_error_device_tilted12 = /** @type {(inputs: Body_Assessment_Error_Device_Tilted12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Handy war bei der Aufnahme geneigt. Stell es aufrecht hin, zwischen Boden und Nabelhöhe, ohne es nach oben oder unten zu richten.`)
};

const it_it2_body_assessment_error_device_tilted12 = /** @type {(inputs: Body_Assessment_Error_Device_Tilted12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il telefono era inclinato al momento dello scatto. Mettilo in verticale tra il pavimento e l'altezza dell'ombelico, senza puntarlo verso l'alto o verso il basso.`)
};

/**
* | output |
* | --- |
* | "The phone was tilted when the photo was taken. Stand it upright between the floor and navel height, without pointing it up or down." |
*
* @param {Body_Assessment_Error_Device_Tilted12Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_error_device_tilted12 = /** @type {((inputs?: Body_Assessment_Error_Device_Tilted12Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Error_Device_Tilted12Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_error_device_tilted12(inputs)
	if (locale === "es-419") return es_419_body_assessment_error_device_tilted12(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_error_device_tilted12(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_error_device_tilted12(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_error_device_tilted12(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_error_device_tilted12(inputs)
	return en_us2_body_assessment_error_device_tilted12(inputs)
});
export { body_assessment_error_device_tilted12 as "body-assessment.error.DEVICE_TILTED" }